import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BhAdPopupComponent } from './bh-ad-popup.component';

@NgModule({
  declarations: [
    BhAdPopupComponent
    ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
  ],
  exports: [
    BhAdPopupComponent
  ]
})
export class BhAdPopupComponentModule { }
